import { Component, Input } from "@angular/core";
import { DIGITAL_MENU_CONSTANTS } from "@src/components/ib-MmB-gastronomic-proposal/constants/gastronomic-proposal-constants";
import { downgradeToAJSComponent } from 'ib-web-commons/utils';

@Component({
    selector: 'ib-digital-menu-allergens-info',
    templateUrl: './ib-digital-menu-allergens-info.component.html',
})

export class IbDigitalMenuAllergensInfoComponent {
    allergensIconUrl = DIGITAL_MENU_CONSTANTS.ALERGENS_ICONS_URL;
    allAllergens = DIGITAL_MENU_CONSTANTS.ALLERGENS_DATA;

    @Input() show_allergens: boolean;
    @Input() disclaimer: string;

    constructor() { }

}

downgradeToAJSComponent('ibDigitalMenuItem', {
    component: IbDigitalMenuAllergensInfoComponent,
    inputs: ['name', 'disclaimer']
}, 'ib-MmB-gastronomic-proposal-module');
